export default "__VITE_ASSET__CFIqIK8e__"